import type { HTMLAttributes, ReactNode } from "react";

export type TechnicalValueKind =
  | "identifier"
  | "digest"
  | "domain"
  | "ip"
  | "path"
  | "url"
  | "email"
  | "timestamp"
  | "version"
  | "code";

export function BidiText({ children, className, ...props }: HTMLAttributes<HTMLElement> & { children: ReactNode }) {
  return <bdi {...props} className={className}>{children}</bdi>;
}

export function TechnicalText({
  children,
  kind,
  className,
  truncate = false,
  ...props
}: Omit<HTMLAttributes<HTMLElement>, "dir"> & {
  children: ReactNode;
  kind: TechnicalValueKind;
  truncate?: boolean;
}) {
  const classes = ["kavoosh-technical", truncate ? "kavoosh-technical--truncated" : "", className ?? ""]
    .filter(Boolean).join(" ");
  return <bdi {...props} dir="ltr" data-technical-kind={kind} className={classes}>{children}</bdi>;
}
